import { render, staticRenderFns } from "./org_video_list.vue?vue&type=template&id=188b5d10&scoped=true"
import script from "./org_video_list.vue?vue&type=script&lang=js"
export * from "./org_video_list.vue?vue&type=script&lang=js"
import style0 from "./org_video_list.vue?vue&type=style&index=0&id=188b5d10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188b5d10",
  null
  
)

export default component.exports